import React, { Component } from 'react';
import { connect } from "react-redux";
import axios from "axios";
import { loginUser, logoutUser, setParentSchools, setSchool } from "../modules/actions";
import { getUserData, getLoggingStatus, getisAuthenticated, getErrorMessage } from "../modules/reducers";
import { BASEURL } from "../Config";

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            error: "",
            emailError: "",
        }
    }

    componentDidMount() {
        this.props.logout();
    }

    handleChange(e) {
        if (e.target.name === "email") {
            this.setState({
                emailError: false
            })
        } 
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isAuthenticated && this.props.isAuthenticated) {
            const parentId = this.props.user && (this.props.user.parentId || this.props.user._id);
            if (!parentId) {
                window.location.href = "myOrders";
                return;
            }
            axios.get(`${BASEURL}/api/v1/parent/getSchools/${parentId}`)
                .then(res => {
                    const schools = res.data || [];
                    this.props.setParentSchools(schools);
                    if (schools.length === 1) {
                        this.props.setSchool(schools[0]);
                        const schoolPath = schools[0].slug || schools[0].name;
                        window.location.href = "school/" + schoolPath;
                    } else if (schools.length > 1) {
                        window.location.href = "selectSchool";
                    } else {
                        window.location.href = "myOrders";
                    }
                })
                .catch(() => {
                    window.location.href = "myOrders";
                });
        }
        if (prevProps.error !== this.props.error) {
            if (this.props.error !== "") {
                this.setState({
                    error: this.props.error
                })

            }
        }
    }

    handleSubmit = () => {
        if (this.state.email === "") {
            this.setState({
                emailError: 'Enter Email'
            })
        } 
        else {
            this.props.login(this.state.email);
        }

    }

    render() {
        return (
            <div className="site-section">
                <div className="container">
                    <div className="row justify-content-center pt-5">
                        <div className="col-md-6">
                            <form action="#" onSubmit={(e) => { e.preventDefault(); this.handleSubmit(); }}>
                                <div className="p-3 p-lg-5 border">
                                    <h2 className="h3 mb-3 text-black text-center">Login</h2>
                                    <div className="form-group row">
                                        <div className="col-md-12">
                                            <label htmlFor="email" className="text-black">Email</label>
                                            <input type="text" className="form-control" id="email" name="email"
                                                onChange={(e) => this.handleChange(e)}
                                                placeholder="Enter your Email" autoComplete="off" />
                                        </div>
                                    </div>
                                    {this.state.emailError ? <p className="text-danger" >{this.state.emailError}</p> : ''}
                                    {this.state.error ? <p className="text-danger">{this.state.error}</p> : ''}
                                    <div className="form-group row">
                                        <div className="col-lg-12">
                                            <button className="btn btn-primary btn-lg btn-block" type="submit">Login</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        user: getUserData(state),
        loggingStatus: getLoggingStatus(state),
        isAuthenticated: getisAuthenticated(state),
        error: getErrorMessage(state),
    }
}

const mapDispatchToProps = dispatch => ({
    login: (email) => dispatch(loginUser(email)),
    logout: () => dispatch(logoutUser()),
    setParentSchools: (schools) => dispatch(setParentSchools(schools)),
    setSchool: (school) => dispatch(setSchool(school)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);